import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// Own constants/actions/components
import { items } from 'services/selectors/shopping-cart';
import { addItemsShoppingCartAction, deleteItemToShoopingCartById } from 'services/actions/shopping-cart';
import { resetExclusivitiesAction } from 'services/actions/exclusivity-experience-remove.js';
import CardStockComp from 'components/card-stock';
import ModalExclusivity from 'components/modal-exclusivity-experience';
import ModalCheck from 'components/modal-check';
import { setId } from 'helpers/random-id';
import { scrollEvent } from 'helpers/scroll-event';
import { hasExclusiveConflict } from 'helpers/exclusivity';

const TypeTravel = (props) => {
  const { details, points, cards } = props;
  const {
    id,
    title,
    image,
    type,
    startDelivery,
    endDelivery,
    numberOfPeople,
    location,
    duration,
    stock,
    exclusivity,
  } = details;
  const stockValidation = stock !== null ? stock : 99;
  const [count, setCount] = useState('');
  const [isCheckedYouMustKnow, setIsCheckedYouMustKnow] = useState(false);
  const { id: pathId, pathName } = useParams();
  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors }, setFocus, clearErrors } = useForm({ mode: 'onChange' });
  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const itemsCart = useSelector(items);
  const sessionActive = Cookies.get('frontSession') !== undefined;
  const [dataItemActual, setDataItemActual] = useState([]);

  const onSubmit = (dataform) => {
    for (let i = 0; i < dataform.count; i += 1) {
      /* eslint-disable */
      const newObjSend = Object.assign({}, dataform, {
        id: setId(),
        experienceId: id,
        title: title,
        image: image,
        delivery: moment(dataform.endDelivery).format('DD/MM/YYYY'),
        startDelivery: moment(dataform.startDelivery).format('DD/MM/YYYY'),
        endDelivery: moment(dataform.endDelivery).format('DD/MM/YYYY'),
        type: type.constant,
        typeName: type.name,
        points: points,
        isGift: false,
        useCrisData: false,
        notes: "",
        membersList: [],
        location: location,
        duration: duration,
        numberOfPeople: numberOfPeople,
        exclusivity: exclusivity,
        stock: stock,
        youShouldKnowCheck: true,
      });
      setDataItemActual([newObjSend]);
      dispatch(addItemsShoppingCartAction(newObjSend));
    }
    handleOpen();
  };

  const handlePlus = () => {
    setFocus('count');
    if (count < stockValidation) {
      setCount(Number(count) + 1);
      clearErrors(['count']);
    }
  };

  const handleLess = () => {
    setFocus('count');
    if (count > 0) {
      setCount(Number(count) - 1);
    }
    if( count-1 <= stockValidation ) {
      clearErrors(['count']);
    }
  };

  const removeAutoExclusivity = (indexExpRemove) => {
    dispatch(deleteItemToShoopingCartById(indexExpRemove));
    dispatch(resetExclusivitiesAction());
  };

  const modalShowCases = () => {
    if (hasExclusiveConflict(dataItemActual, cards)) {
      return (
        <ModalExclusivity
          stateInitial={show}
          close={handleClose}
          itemsCart={dataItemActual}
          removeFunc={removeAutoExclusivity}
          path="mis-experiencias" />
      );
    }

    return (
      <ModalCheck
        stateInitial={show}
        close={handleClose}
        itemsCart={dataItemActual}
        path="mis-experiencias" />
    );
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <div className="sticky-resumen mb-30 mt-lg-60 d-none d-lg-block d-xl-block">
      { itemsCart.length > 0
        && dataItemActual
        && dataItemActual.length > 0
        && sessionActive
        ? modalShowCases() : (
          <ModalCheck
            stateInitial={show}
            close={handleClose}
            itemsCart={dataItemActual}
            path="mis-experiencias" />
        ) }
      { stockValidation < 5 ? <CardStockComp /> : '' }
      <div className="card-main bg-color-westar p-15">
        <h2 className="text-tangaroa">{`${(Number(points)).toLocaleString('es-MX')} Puntos Aeroméxico Rewards`}</h2>
        <h3 className="py-15 text-tangaroa text-normal">Tu Experiencia Aeroméxico Rewards</h3>
        {/* eslint-disable react/jsx-props-no-spreading */}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="select-start text-tangaroa">Fecha de ida</label>
          <select {...register('startDelivery')} className="custom-select select-start not-pointer mb-30 text-tangaroa" id="select-start" readOnly defaultValue={startDelivery}>
            <option value={startDelivery} defaultValue>{moment(startDelivery).format('DD/MM/YYYY')}</option>
          </select>
          <label htmlFor="select-end">Fecha de regreso</label>
          <select {...register('endDelivery')} className="custom-select options not-pointer mb-30 text-tangaroa" id="select-end" readOnly defaultValue={endDelivery}>
            <option value={endDelivery} defaultValue>{moment(endDelivery).format('DD/MM/YYYY')}</option>
          </select>
          <label htmlFor="count-input">¿Cuántas Experiencias quieres adquirir?</label>
          <Row className="input-count pb-3">
            <Col xs={3} className="pr-0">
              <button type="button" className="btn-form btn-right" onClick={handleLess}>-</button>
            </Col>
            <Col xs={6} className="px-0">
              <input
                {...register('count', {
                  required: true,
                  min: 1,
                  max: stockValidation,
                  onChange: e => setCount(e.target.value.replace(new RegExp(/[^\d]/,'ig'), '')),
                })}
                value={count}
                id="count"
                name="count"
                placeholder="0"
                className="count-input"
                type="text" />
            </Col>
            <Col xs={3} className="pl-0">
              <button type="button" className="btn-form btn-left" onClick={handlePlus}>+</button>
            </Col>
            <Col lg={10}>
              {errors.count?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors.count?.type === 'min' && <small className="error-msg">* El mínimo de compra es 1</small>}
              {errors.count?.type === 'max' && <small className="error-msg">{`* El límite del stock es: ${stockValidation}`}</small>}
            </Col>
          </Row>
          <Row>
            <div className="custom-control custom-checkbox pl-5">
              <input
                id="check"
                className="custom-control-input"
                type="checkbox"
                onChange={() => setIsCheckedYouMustKnow(!isCheckedYouMustKnow)} />
              <label htmlFor="check" className="custom-control-label text-tangaroa">
                <p className="ft-12 text-tangaroa font-weight-normal mb-2">
                  Acepto que he leído el apartado <HashLink to={`/${pathName}/${pathId}#experience-info`} className="link">‘Lo que debes saber’</HashLink> de esta Experiencia
                </p>
              </label>
            </div>
          </Row>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={stockValidation === 0 || !isCheckedYouMustKnow}>
            Agregar al carrito
          </button>
        </Form>
      </div>
    </div>
  );
};

TypeTravel.propTypes = {
  details: PropTypes.object.isRequired,
  points: PropTypes.number.isRequired,
  cards: PropTypes.array.isRequired,
};

export default TypeTravel;
